import { AI_JOB_TIMEOUT_MS } from '../domain/job-timeout-policy';
import type { ApiAiJob } from './types';

export const QUEUED_JOB_TIMEOUT_MS = AI_JOB_TIMEOUT_MS;
export const ACTIVE_JOB_TIMEOUT_MS = AI_JOB_TIMEOUT_MS;

function parseJobTimestamp(value: string | null | undefined): Date | null {
  if (!value) {
    return null;
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function isClientTrackableJobStatus(status: string): boolean {
  return (
    status === 'queued' ||
    status === 'creating' ||
    status === 'running' ||
    status === 'pending_output'
  );
}

export function shouldContinueEnhancerJobPolling(job: ApiAiJob): boolean {
  return isClientTrackableJobStatus(job.status);
}

export function shouldTimeoutEnhancerJobOnClient(
  job: ApiAiJob,
  now = new Date()
): boolean {
  if (!isClientTrackableJobStatus(job.status)) {
    return false;
  }

  const updatedAt = parseJobTimestamp(job.updatedAt);
  const createdAt = parseJobTimestamp(job.createdAt);
  const startedAt = parseJobTimestamp(job.startedAt);

  if (job.status === 'queued') {
    const baseline = updatedAt ?? createdAt;
    if (!baseline) {
      return false;
    }
    return now.getTime() - baseline.getTime() >= QUEUED_JOB_TIMEOUT_MS;
  }

  const baseline =
    job.status === 'creating'
      ? (updatedAt ?? createdAt)
      : (startedAt ?? updatedAt ?? createdAt);
  if (!baseline) {
    return false;
  }

  return now.getTime() - baseline.getTime() >= ACTIVE_JOB_TIMEOUT_MS;
}
